import {ContentContainer} from '@coolcolduk/ui-mui';
import {UserPermission} from '@cp/model';
import {ProtectedRouteChildrenProps} from '../../../components/template/ProtectedRoute';
import AccountInfo from './AccountInfo';
import GeneralSettingsCard from './GeneralSettingsCard';
import TradingViewExtensionCard from './TradingViewExtensionCard';

export default function GeneralSettingsPage({user}: ProtectedRouteChildrenProps) {
  return (
    <ContentContainer data-testid="general-settings-page">
      <AccountInfo user={user} />
      {user?.roles?.includes(UserPermission.ADMIN) && <TradingViewExtensionCard />}
      <GeneralSettingsCard user={user} />
    </ContentContainer>
  );
}
